import ViewGridComponent from './ViewGridComponent'
export * from './ViewGridComponent'

export default ViewGridComponent
